module.exports = __webpack_public_path__ + "static/media/info-icon.e8a5f092.svg";